module.exports = __webpack_public_path__ + "img/creator.4ca3d8e8.svg";